/*!
 * @pixi/canvas-text - v6.5.9
 * Compiled Wed, 25 Jan 2023 05:01:45 UTC
 *
 * @pixi/canvas-text is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
import{Text as t}from"@pixi/text";import{Sprite as i}from"@pixi/sprite";t.prototype._renderCanvas=function(t){this._autoResolution&&this._resolution!==t.resolution&&(this._resolution=t.resolution,this.dirty=!0),this.updateText(!0),i.prototype._renderCanvas.call(this,t)};
//# sourceMappingURL=canvas-text.min.mjs.map
